/**
 * The visit's service report as it prints (piece 29; decisions 1910, 2061;
 * T1243): the sheet's title, the facts it adds, and Region 14's lines above the
 * customer's and the lead worker's drawn signatures; and the visit's own page
 * (decision 2062; T1263) with its completion sheet, Service Report: Print and
 * Send, and Book a Return Visit. Spread into the one lookup in `strings.ts`.
 * 🔨 This file imports nothing.
 */
export const VISIT_REPORT_STRINGS = {
  'workOrder.serviceReport.visit': 'Visit',
  'workOrder.serviceReport.completed': 'Completed',
  'workOrder.serviceReport.workDone': 'Work done: {summary}',
  'workOrder.serviceReport.couldNotComplete': 'Could not complete: {note}',
  'workOrder.serviceReport.customerSigned': 'Customer: {name}',
  'workOrder.serviceReport.customerUnsigned': 'Customer: {reason}',
  'workOrder.serviceReport.leadSigned': 'Lead: {name}',
  'workOrder.serviceReport.jobSignature': '{signer}, on {visit}',
  'workOrder.serviceReport.fileDescription': 'Service report, {visit}',
  'workOrder.serviceReport.signatureFile': 'Signature drawn by {name}, {visit}',
  'workOrder.visitPage.title': '{number} · {visit}',
  'workOrder.visitPage.backToJob': 'Back to {number}',
  'workOrder.visitPage.notFound': 'This visit was not found on the job.',
  'workOrder.visitPage.facts': 'The Visit',
  'workOrder.visitPage.customer': 'Customer',
  'workOrder.visitPage.site': 'Site',
  'workOrder.visitPage.window': 'Date and Window',
  'workOrder.visitPage.notYet': 'Not yet',
  'workOrder.visitPage.stampBy': 'by {name}',
  'workOrder.visitPage.crew': 'Who Went',
  'workOrder.visitPage.leadMark': 'Lead',
  'workOrder.visitPage.nobody': 'Nobody is named on this visit.',
  'workOrder.visitPage.lines': 'Lines Worked',
  'workOrder.visitPage.linesHint': 'Every line of the job while the report is open, with this visit’s hours. A signed report lists the lines this visit’s time names, or every line if none.',
  'workOrder.visitPage.lineLabel': 'Line {line}',
  'workOrder.visitPage.hours': '{hours} on this visit',
  'workOrder.visitPage.noWork': 'No work performed is typed yet.',
  'workOrder.visitPage.parts': 'Parts Fitted',
  'workOrder.visitPage.partsHint': 'The parts fitted on the job; a part names no visit yet.',
  'workOrder.visitPage.noParts': 'No part is fitted on this job.',
  'workOrder.visitPage.partLine': '{quantity} {unit}',
  'workOrder.visitPage.sheet': 'Completion Sheet',
  'workOrder.visitPage.sheetOpen': 'The sheet is signed when the lead completes the visit.',
  'workOrder.visitPage.notLead': 'Only the visit’s lead completes it.',
  'workOrder.visitPage.notStarted': 'The visit completes once it has started: tap Arrived or Clock In on My Jobs first.',
  'workOrder.visitPage.outcome': 'Outcome',
  'workOrder.visitPage.workSummary': 'Work Done',
  'workOrder.visitPage.comment': 'Customer’s Comment',
  'workOrder.visitPage.customerSigned': 'Customer’s Signature',
  'workOrder.visitPage.leadSigned': 'Lead’s Signature',
  'workOrder.visitPage.complete': 'Complete the Visit',
  'workOrder.visitPage.completeTitle': 'Complete the Visit',
  'workOrder.visitPage.completeHint': 'The customer signs first, then you sign as the lead. Your signature freezes the sheet as the visit’s service report.',
  'workOrder.visitPage.outcomeCompleted': 'Completed',
  'workOrder.visitPage.outcomeCouldNot': 'Could Not Complete',
  'workOrder.visitPage.outcomeNote': 'What Stopped the Work',
  'workOrder.visitPage.workPerformed': 'Work Performed on Line {line}',
  'workOrder.visitPage.customerStep': 'The Customer Signs',
  'workOrder.visitPage.customerName': 'Customer’s Name',
  'workOrder.visitPage.signed': 'Signed',
  'workOrder.visitPage.leadStep': 'The Lead Signs',
  'workOrder.visitPage.leadName': 'Your Name',
  'workOrder.visitPage.pad': 'Sign Here',
  'workOrder.visitPage.clearPad': 'Clear',
  'workOrder.visitPage.sign': 'Sign and Complete',
  'workOrder.visitPage.completed': 'The visit is complete, and its signed service report is kept on the job.',
  'workOrder.visitPage.print': 'Service Report: Print',
  'workOrder.visitPage.send': 'Service Report: Send',
  'workOrder.visitPage.sendTitle': 'Send the Service Report',
  'workOrder.visitPage.sendHint': 'The signed sheet goes as a PDF to the contacts you tick.',
  // Decision 2080: whom the window opens ticked, and why.
  'workOrder.visitPage.sendFromRule': 'Ticked: the contacts this customer’s Complete message goes to. Change the ticks for this send alone.',
  'workOrder.visitPage.sendNoRule': 'This customer has no Complete message switched on, so the Deal’s primary contact opens ticked. Set the Complete message on the customer’s Field Service tile.',
  'workOrder.visitPage.recipients': 'Send To',
  'workOrder.visitPage.noAddress': 'no email address',
  'workOrder.visitPage.noContacts': 'This customer has no contact to send to.',
  'workOrder.visitPage.message': 'A Line of Your Own',
  'workOrder.visitPage.sent': 'The service report was sent to {to}.',
  'workOrder.visitPage.sendFailed': 'The service report did not go out to {to}; it is in the failure queue.',
  'workOrder.visitPage.sendSubject': 'Service report: {number}, {visit}',
  'workOrder.visitPage.sendBody': 'Attached is the signed service report for {number}, visit {visit}, at {company}.',
  'workOrder.visitPage.bookReturn': 'Book a Return Visit',
  'workOrder.visitPage.returnBooked': 'The return visit is booked.',
  'workOrder.visitPage.cancelled': 'This visit was canceled: {reason}',
  // Decision 2910 (T2184): the Service Report as a document of the visit, its states, its page's bar and tiles.
  'documentName.serviceReport': 'Service Report',
  'documentNames.serviceReport': 'Service Reports',
  'serviceReport.number': '{number} · SR{visit}',
  'serviceReport.state.open': 'Open',
  'serviceReport.state.signed': 'Signed',
  'serviceReport.state.sent': 'Sent',
  'serviceReport.state.void': 'Void',
  'serviceReport.state.none': 'Not Opened Yet',
  'serviceReport.complete.workHint': 'Write what was done. The next step shows the sheet as it will print, and the customer signs beneath it.',
  'serviceReport.complete.next': 'Show the Sheet',
  'serviceReport.complete.back': 'Back to the Work Done',
  'serviceReport.complete.previewTitle': 'The sheet as it will print',
  'serviceReport.complete.noPreview': 'The sheet could not be drawn here. It is printed from the Service Report template when you sign.',
  'serviceReport.complete.noComment': 'Nobody on site leaves no comment, so the sheet is kept without the one typed.',
  'serviceReport.sheetDrawing': 'Drawing the signed sheet…',
  'serviceReport.sheetFailed': 'The signed sheet could not be drawn here. Service Report: Print opens it.',
  'serviceReport.notOpenedHint': 'The report opens at this visit’s first On My Way, Arrived or Clock In.',
  'serviceReport.bar.clockOut': 'Clock Out',
  'serviceReport.bar.recordTime': 'Record Time',
  'serviceReport.bar.addNote': 'Add Note',
  'serviceReport.bar.addPhoto': 'Add Photo',
  'serviceReport.clockInLine': 'Line',
  'serviceReport.clockInHint': 'Choose the line you are starting work on.',
  'serviceReport.recordTitle': 'Record Time',
  'serviceReport.running': 'Your clock runs on {line} since {at}.',
  'serviceReport.toldRecorded': 'Your time is recorded.',
  'serviceReport.notes': 'Notes',
  'serviceReport.notesHint': 'What you found and did on site, newest last. A note is kept as written.',
  'serviceReport.noNotes': 'No note is written on this visit yet.',
  'serviceReport.noteBy': '{name} · {at}',
  'serviceReport.noteTitle': 'Add Note',
  'serviceReport.noteBody': 'Note',
  'serviceReport.photoTitle': 'Add Photo',
  'serviceReport.noteAdded': 'Your note is added.',
  // Decision 4320 (T2430): each line of Lines Worked a card, worked with Start Line and End Line, its entries beneath.
  'serviceReport.card.startLine': 'Start Line',
  'serviceReport.card.endLine': 'End Line',
  // Decision 12680 (T3821): the worker's own On My Way, drawn beside Start Line, and the Travel a first Clock In offers with no minutes filled.
  'workOrder.clock.startTravel': 'Start Travel',
  'workOrder.clock.travelHint': 'You did not tap Start Travel before this Clock In. Type the minutes you drove to record them as travel, or decline and nothing is written.',
  'serviceReport.card.running': 'Your clock runs on this line since {at}.',
  'serviceReport.card.noEntries': 'Nothing is posted under this line yet.',
  'serviceReport.card.noTime': 'No time on this visit yet',
  // 🔒 Decision 5571: who the visit sent for the line.
  'serviceReport.card.sent': 'Sent: {names}',
  'serviceReport.card.sentNobody': 'Nobody on this visit is sent for this line.',
  'serviceReport.feed.addNote': 'Add Note on the Visit',
  'serviceReport.note.onLine': 'Posted under {line}.',
  'serviceReport.note.onVisit': 'Posted on the visit, under no line.',
  'serviceReport.note.pictures': 'Pictures',
  // Decision 4320: one photo control, camera first where the pointer is coarse, and a note's pictures as thumbnails.
  'serviceReport.photo.take': 'Take Photo',
  'serviceReport.photo.choose': 'Choose a File',
  'serviceReport.photo.captionFor': 'Caption for {name}',
  'serviceReport.photo.remove': 'Remove',
  'serviceReport.photo.tooMany': 'A note carries at most {max} pictures; the rest were left out.',
  'serviceReport.photo.scanning': 'Waiting on its scan',
  'serviceReport.photo.blocked': 'Held by the scan',
  'serviceReport.photo.gone': 'No longer stored',
  'serviceReport.photo.view': 'Photo',
  'serviceReport.photo.takenBy': 'Taken by {name} · {at}',
  'serviceReport.photo.openLabel': 'Open the photo {name}',
  // Decision 13310: Link to Asset on a visit photo, the asset it stands on, and the window that picks it.
  'serviceReport.photo.linkAsset': 'Link to Asset',
  'serviceReport.photo.linkedTo': 'Asset: {name}',
  'serviceReport.photo.linkField': 'Asset',
  'serviceReport.photo.linkHint': 'The photo also stands on the asset’s Files. A photo posted under a line that names an asset is linked to it already.',
  'serviceReport.photo.linkNone': 'No asset stands on this job’s lines or at its site, so there is nothing to link the photo to.',
  'serviceReport.photo.linked': 'The photo is linked to {name}.',
  'serviceReport.checklists': 'Checklists',
  'serviceReport.documents.sheet': 'Work Order Sheet',
  'serviceReport.documents.print': 'Print',
  'serviceReport.documents.open': 'Open',
  'serviceReport.documents.none': 'No document is raised on this job beyond its own sheet.',
  'serviceReport.documents.invoice': 'Invoice',
  'serviceReport.documents.draftInvoice': 'Draft Invoice',
  'serviceReport.visits.hours': 'Hours',
  'serviceReport.visits.notes': 'Notes',
  'serviceReport.visits.report': 'Report',
  'serviceReport.myJobsButton': 'Service Report',
  'serviceReport.noMoney': 'Prices are not shown on a service report; the invoice from this job carries the money.',
  'serviceReport.print.arrived': 'Arrived: {at}',
  'serviceReport.print.left': 'Left: {at}',
  'serviceReport.print.onSite': 'Hours on site: {hours}',
  'serviceReport.print.note': '{at} · {name}: {body}',
  'serviceReport.print.photoOnly': '{at} · {name}: a photo',
  'serviceReport.print.check': '{title}: {answer}',
  'serviceReport.print.checkBy': '{title}: {answer} · {name}, {at}',
  'serviceReport.print.notAnswered': 'not answered',
  'serviceReport.print.partLine': '{item}, {quantity} {unit}',
  'serviceReport.print.noParts': 'No part fitted.',
  'document.print.column.workPerformed': 'Work Performed',
  'print.columnSet.service': 'Service report',
  'document.print.region.trip': 'The Trip',
  'document.print.region.problemReported': 'Problem Reported',
  'document.print.region.partsFitted': 'Parts Fitted',
  'document.print.region.checklistResults': 'Checklist Results',
  'document.print.region.notes': 'Notes',
  'document.print.region.customerComment': 'Customer’s Comment',
  'document.print.region.customerSignature': 'Customer’s Signature',
} as const;
